import React from 'react';
import { NotificationI } from '../../../types';
import { format } from 'date-fns';
import { requestDetailsModalCall } from '../../../containers/MainWrapper/MainWrapper';
import { observer } from 'mobx-react';

interface NotificationViewPropsI {
  message: NotificationI,
  deleteNotif: (msgId: number) => void,
  onClose: () => void,
}

export const NotificationView = observer((props: NotificationViewPropsI) => {
  const {message, onClose , deleteNotif} = props;
  return <div className={'notification_item'}>
    <b>{message.authorName}</b> will be absent from {format(new Date(message.startDate), 'dd.MM.yyyy')} to {format(new Date(message.endDate), 'dd.MM.yyyy')} ({message.duration} working day(s)).
    <span
      onClick={()=>{
        onClose();
        deleteNotif(message.id);
        requestDetailsModalCall.showImmediately({id: message.leaveRequestId});
      }}>
    View Details</span></div>;
});
